# Toggles the classes on the fake checkboxes. CSS implementation doesn't allows to use the builtin css selectors, so it
# has to be done through JS. It adds a click listener, but also initialise the correct CSS class on page change.

$(document).on 'change', '[type="checkbox"]', ->
  $this = $ this
  $this.parent().toggleClass 'checked', this.checked

init = ->
  $('label:has([type="checkbox"]:checked)').addClass 'checked'
  $('label:has([type="checkbox"]:disabled)').addClass 'disabled'

$(document).ready(init)
